import * as React from 'react';
import CommissairesProps, { Commissiary as CommissaryProps } from './type';
import { Container } from '../helpers/Grid';
import './styles.scss';

const Commissary = ({
  name,
  nationality,
  role,
}: CommissaryProps) => (
  <div className="commissiary">
    <div className="commissiary__details">
      <div className="commissiary__name">
        {name}
      </div>
      <div className="commissiary__role">
        {role}
      </div>
    </div>
    <div className="commissiary__nationality">
      {nationality}
    </div>
  </div>
);

const Commissaires = ({
  title,
  subtitle,
  items,
}: CommissairesProps) => (
  <section className="commissaires">
    <Container>
      <div className="commissaires__inner">
        <div className="commissaires__head">
          <h3 className="commissaires__title">
            {title}
          </h3>
          <div className="commissaires__sub-title">
            {subtitle}
          </div>
        </div>
        <div className="commissaires__list">
          {items.map((item) => (
            <Commissary {...item} />
          ))}
        </div>
      </div>
    </Container>
  </section>
);

export default Commissaires;
